import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../contexts/StoreProvider';
import { Heart } from 'lucide-react';

const FavoritesScreen = () => {
  const { products, toggleFavorite } = useStore();
  
  // products in context are already updated with the isFavorite flag
  const favoriteProducts = products.filter(p => p.isFavorite);

  if (favoriteProducts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-32">
        <Heart size={48} className="text-gray-300 mb-4" />
        <h2 className="text-xl font-bold text-black mb-2 tracking-widest uppercase">No Favorites Yet</h2>
        <p className="text-gray-500 mb-8">You haven't liked any items yet.</p>
        <Link 
          to="/store"
          className="bg-black text-white px-8 py-4 font-bold tracking-widest uppercase hover:bg-gray-900 transition-colors"
        >
          Browse Store
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex items-center mb-8 border-b pb-4">
        <h1 className="text-2xl font-bold tracking-widest uppercase">My Favorites</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {favoriteProducts.map((product) => (
          <div key={product.id} className="group flex flex-col bg-white overflow-hidden hover:shadow-lg transition-shadow duration-300">
            <div className="relative aspect-[3/4] bg-gray-100 overflow-hidden">
              {product.images && product.images.length > 0 ? (
                <img
                  src={product.images[0].image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">
                  No Image
                </div>
              )}
              
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleFavorite(product.id);
                }}
                className="absolute top-3 right-3 p-2 bg-white/90 backdrop-blur rounded-full hover:bg-white transition-colors shadow-sm z-10"
              >
                <Heart
                  size={20}
                  className="fill-red-500 text-red-500"
                />
              </button>
              
              <Link to={`/store/product/${product.id}`} className="absolute inset-0 z-0"></Link>
            </div>
            
            <div className="p-4 flex flex-col flex-grow">
              <span className="text-[10px] font-bold tracking-widest text-gray-500 uppercase mb-1">
                {product.category_detail?.name || 'GENERAL'}
              </span>
              <Link to={`/store/product/${product.id}`} className="text-sm font-semibold text-black hover:underline mb-2 line-clamp-1">
                {product.name}
              </Link>
              <span className="text-base font-bold text-black mt-auto">
                ₵{parseFloat(product.price).toFixed(2)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavoritesScreen;
